import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { EditFeatureState } from "../editFeature.reducer";

export const setGeometryStylePartialReducer: IPartialReducer<EditFeatureState> = (state, action) => {
    return {
        ...state,
        style: action.style,
    };
};
